import {
  IStatusPropertyTypeInterfaces,
} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/StatusPropertyTypeStrategy/types/IStatusPropertyTypeInterfaces'
import {resolveNestedSubPropertyValue} from '@toolify/client/src/modules/databases/utils/resolveNestedSubPropertyValue'

export function resolveStatusSubPropertyValue(value: unknown, subProperty: string, availableValues?: unknown): unknown {
  if(typeof value !== 'string' || subProperty !== 'statusGroupType') {
    return resolveNestedSubPropertyValue(value, subProperty)
  }
  const statuses = (availableValues as IStatusPropertyTypeInterfaces['fullValue'][]) || []
  return statuses.find(status => status?.id === value)?.groupType ?? null
}
